<template>
  <div class="box10">
    <pageTitle
      title="从入门到就业 他们已通过博学谷<br/>成功转行、就业"
      titleColor="#3E4F48"
    />
    <div class="topContent">
      <div class="item" v-for="(item, index) in topBoxList" :key="index">
        <p>
          {{ item.num }}<span>{{ item.unit }}</span>
        </p>
        <p>{{ item.txt }}</p>
      </div>
    </div>
    <div class="content-box" @scroll="handleScroll">
      <div class="content" ref="content">
        <div class="content-top">
          <div class="name">姓名</div>
          <div class="oldSalay">学前薪资</div>
          <div class="newSalay">就业薪资</div>
          <div class="offer">offer</div>
          <div class="company">入职公司</div>
          <div class="age">年龄</div>
          <div class="education">学历</div>
          <div class="major">大学专业</div>
          <div class="work">学前岗位</div>
          <div class="day">工作年限</div>
        </div>
        <div class="item" v-for="(item, index) in salaryList" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="oldSalay">{{ item.wages }}</div>
          <div class="newSalay">{{ item.salary }}</div>
          <div class="offer">{{ item.offer }}</div>
          <div class="company">{{ item.unit }}</div>
          <div class="age">{{ item.age }}</div>
          <div class="education">{{ item.education }}</div>
          <div class="major">{{ item.major }}</div>
          <div class="work">{{ item.jobs }}</div>
          <div class="day">{{ item.workYear }}</div>
        </div>
      </div>
      <div class="seat"></div>
    </div>
    <div class="box">
      <!-- <div class="scorll-box">
        <div class="scorll-block" :style="styleVar"></div>
      </div> -->
    </div>
    <p class="txt">
      *
      为了避免对学员造成影响，以上数据做了部分隐藏处理，相关数据来源于公司内部真实统计
    </p>
    <!-- <div class="swiper-content">
      <swiper :options="swiperOption2" ref="mySwiper2" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in 8"
          :key="index"
        >
          <img
            :src="require(`../../../assets/coursePage/web/box10/${index}.jpg`)"
            alt
          />
        </swiper-slide>
      </swiper>

      <div class="swiper-pagination-box12"></div>
    </div> -->
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      topBoxList: [
        {
          num: "10977.59",
          unit: "元",
          txt: "全体平均薪资"
        },
        {
          num: "13803.57",
          unit: "元",
          txt: "一线平均薪资"
        },
        {
          num: "1.38",
          unit: "个",
          txt: "平均offer数量"
        },
        {
          num: "96.38",
          unit: "%",
          txt: "全体平均涨薪幅度"
        },
        {
          num: "132.86",
          unit: "%",
          txt: "一线平均涨薪幅度"
        }
      ],
      
      salaryList: [
        {
          name: "杨**",
          age: "31",
          education: "本科",
          major: "刑事科学技术",
          jobs: "科员",
          workYear: "7",
          wages: "4000",
          salary: "17000",
          offer: "2",
          unit: "上海**信息科技有限公司"
        },
        {
          name: "倪**",
          age: "27",
          education: "本科",
          major: "会计学",
          jobs: "教研老师",
          workYear: "1",
          wages: "6000",
          salary: "14433",
          offer: "3",
          unit: "南京某药企"
        },
        {
          name: "付**",
          age: "25",
          education: "本科",
          major: "物联网工程",
          jobs: "小学英语老师",
          workYear: "1",
          wages: "8000",
          salary: "13500",
          offer: "3",
          unit: "**国际杭州分公司"
        },
        {
          name: "秦**",
          age: "31",
          education: "本科",
          major: "软件工程",
          jobs: "Android开发",
          workYear: "5",
          wages: "10000",
          salary: "18000",
          offer: "2",
          unit: "北京**科技有限公司"
        },
        {
          name: "王**",
          age: "28",
          education: "专科",
          major: "国际金融",
          jobs: "审核",
          workYear: "2",
          wages: "5000",
          salary: "11000",
          offer: "3",
          unit: "深圳市**股份有限公司"
        },
        {
          name: "张**",
          age: "25",
          education: "研究生",
          major: "地理信息科学",
          jobs: "大数据研究员",
          workYear: "1",
          wages: "保密",
          salary: "10000",
          offer: "1",
          unit: "杭州**技术有限公司"
        },
        {
          name: "唐**",
          age: "22",
          education: "本科",
          major: "地理信息科学",
          jobs: "GIS开发",
          workYear: "1",
          wages: "5500",
          salary: "12930",
          offer: "1",
          unit: "南京**有限公司"
        },
        {
          name: "万**",
          age: "26",
          education: "专科",
          major: "船舶工程技术",
          jobs: "安全员",
          workYear: "4",
          wages: "4000",
          salary: "10000",
          offer: "1",
          unit: "武汉**股份有限公司"
        },
        {
          name: "张**",
          age: "23",
          education: "专科",
          major: "软件技术",
          jobs: "保密调试",
          workYear: "1",
          wages: "7000",
          salary: "11000",
          offer: "1",
          unit: "北京**科技有限公司"
        },
        {
          name: "郑**",
          age: "23",
          education: "本科",
          major: "材料科学与工程",
          jobs: "生产助理",
          workYear: "0.5",
          wages: "8000",
          salary: "12000",
          offer: "1",
          unit: "上海**科技有限公司"
        },
        {
          name: "施**",
          age: "27",
          education: "本科",
          major: "会计学",
          jobs: "财务",
          workYear: "3",
          wages: "7000",
          salary: "12000",
          offer: "1",
          unit: "**科技有限公司"
        },
        {
          name: "吴**",
          age: "26",
          education: "本科",
          major: "会计学",
          jobs: "电商",
          workYear: "3",
          wages: "保密",
          salary: "13000",
          offer: "1",
          unit: "河南**有限公司"
        },
      ],

      scroll: 0,
      swiperOption2: {
        loop: true, // 循环模式选项

        spaceBetween: 0,
        autoplay: false,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          slideShadows: true, // 页面阴影效果
          rotate: 0, // 旋转的角度
          stretch: 50, // 拉伸   图片间左右的间距和密集度
          depth: 200, // 深度   切换图片间上下的间距和密集度
          modifier: 0.9, // 修正值 该值越大前面的效果越明显
        },
        pagination: {
          el: ".swiper-pagination-box12",
        },
      },
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box10 {
  position: relative;
  padding: 80px 0px 88px;
  width: 100%;
  background: linear-gradient(162deg, #effff6 0%, #fafffc 47%, #ffffff 100%);
  overflow: hidden;

  .topContent {
    background: url("../../../assets/coursePage/web/box10/topContent.png")
      no-repeat;
    background-size: cover;
    margin: 48px auto;
    padding: 34px 32px 32px;
    box-sizing: border-box;
    display: flex;
    width: 686px;
    height: 312px;
    justify-content: space-between;
    align-content: space-between;
    flex-wrap: wrap;
    text-align: center;

    .item {
      text-align: center;
      p:nth-child(1) {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #00b589;
        line-height: 48px;
        span {
          font-size: 24px;
        }
      }
      p:nth-child(2) {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 40px;
        margin-top: 10px;
      }
    }
    .item:nth-child(1) {
      margin-left: 100px;
    }
    .item:nth-child(2) {
      margin-left: 80px;
      position: relative;
      right: 104px;
    }
  }
  .box {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .scorll-box {
    transform: translate(-50%, 0px);
    width: 48px;
    height: 6px;
    background: #c0ebe1;
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 24px;
      height: 6px;
      background: #2ebe9c;
      border-radius: 3px;
    }
  }

  .content-box {
    width: 100%;
    padding: 0px 32px;
    padding-bottom: 22px;
    overflow-x: auto;
    box-sizing: border-box;
    position: relative;
    display: flex;
  }
  .content-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .content {
    width: 1440px;
    flex-shrink: 0;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(12, 158, 123, 0.12);
    border-radius: 24px;
    overflow: hidden;
    position: relative;
    .sex {
      width: 96px;
    }
    .age {
      width: 96px;
    }

    .major {
      width: 170px;
    }

    .education {
      width: 128px;
    }

    .day {
      width: 128px;
    }

    .name {
      width: 120px;
    }
    .offer {
      width: 96px;
    }
    .work {
      width: 144px;
    }

    .oldSalay {
      width: 144px;
    }
    .newSalay {
      width: 144px;
    }
    .company {
      width: 270px;
    }

    .content-top {
      display: flex;
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #1d2129;
      background: url("../../../assets/coursePage/web/box10/tableTop.png")
        no-repeat;
      background-size: contain;
    }

    .item {
      display: flex;
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);

      .newSalay {
        color: #00b589;
      }
    }
  }

  .swiper-content {
    position: relative;

    margin-top: 80px;

    img {
      padding: 4px;
      width: 406px;
      height: 662px;
      background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
    }

    .swiper-slide {
      display: flex;
      align-items: center;
      padding: 4px;
      width: 450px;
      height: 800px;
      border-radius: 24px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 406px;
        height: 720px;
      }
    }
    .swiper-slide-active {
      img {
        width: 450px;
        height: 800px;
        border-radius: 24px;
      }
    }
    .swiper-pagination-box12 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      bottom: -37px;
    }
  }
}
/deep/.swiper-pagination-bullet {
  margin: 0px 4px;
  width: 12px;
  height: 6px;
  background: #c0ebe1;
  border-radius: 3px;
  opacity: 1;
}

/deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 24px;
  height: 6px;
  background: #2ebe9c;
  border-radius: 3px;
}
.txt {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #86909c;
  line-height: 36px;
  width: 654px;
  margin: 24px auto 0;
  text-indent: -22px;
  padding-left: 22px;
}
</style>
